export enum enmReservationStatus {
    Ok,
    OnRequest,
    NoShow,
    GoShow,
    Option
}
